import { COL_COLORS } from './canvasTypes'

export function PresetVisual({ gridTemplate }: { gridTemplate: string }) {
  const frValues = gridTemplate.split(' ').map((v) => parseInt(v, 10))
  return (
    <div className="mb-1.5 flex h-5 w-full overflow-hidden rounded border border-line">
      {frValues.map((v, i) => (
        <div
          key={i}
          style={{ flex: v }}
          className={`border-r border-line last:border-0 ${COL_COLORS[i].bg}`}
        />
      ))}
    </div>
  )
}
